<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'流程实例管理'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <!--表单-->


            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="流程名称">
							    <el-input clearable v-model="q.defnameLike"></el-input>
							</el-form-item>
							<el-form-item label="流程定义的key">
							    <el-input clearable v-model="q.defkeyLike"></el-input>
							</el-form-item>
							<el-form-item label="流程id">
							    <el-input clearable v-model="q.instidLike"></el-input>
							</el-form-item>
							<el-form-item label="业务主键">
							    <el-input clearable v-model="q.ywidLike"></el-input>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="可用标志">
										<brselect clearable category="shifou_keyong" :v="q.delflag" v-model="q.delflag"></brselect>
									</el-form-item>
									<el-form-item label="流程类型">
										<brselect clearable category="progress_type" :v="q.reftype" v-model="q.reftype"></brselect>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						</div>
					</div>
                </div>
            </div>



            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
						border
                        style="width: 100%"
                >
                    <el-table-column
                            prop="id"
                            label="主键"
							fixed
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="defid"
                            label="流程定义id"
							:show-overflow-tooltip="true"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="defkey"
                            label="流程定义key"
							:show-overflow-tooltip="true"
                            width="240">
                    </el-table-column>
                    <el-table-column
                            prop="defname"
                            label="流程定义名称"
							:show-overflow-tooltip="true"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="defversion"
                            label="流程版本"
							:show-overflow-tooltip="true"
                            width="90">
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="流程状态"
							:show-overflow-tooltip="true"
                            width="90">
                    </el-table-column>
                    <el-table-column
                            prop="reftype"
                            label="业务类型"
							:show-overflow-tooltip="true"
                            width="90">
                        <template slot-scope="scope">
                            <dictname category="progress_type" :v="scope.row.reftype"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="refid"
                            label="业务主键"
							:show-overflow-tooltip="true"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="delflag"
                            label="是否可用"
							:show-overflow-tooltip="true"
                            width="90">
                        <template slot-scope="scope">
                            <dictname category="shifou_keyong" :v="scope.row.delflag"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="des"
                            label="描述"
							:show-overflow-tooltip="true"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            prop="cucode"
                            label="创建人id"
							:show-overflow-tooltip="true"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="cuname"
                            label="创建人"
							:show-overflow-tooltip="true"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建时间"
							:show-overflow-tooltip="true"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="lucode"
                            label="更新人id"
							:show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="最后更新时间"
							:show-overflow-tooltip="true"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="finishtime"
                            label="流程的结束时间"
							:show-overflow-tooltip="true"
                            width="160">
                    </el-table-column>


                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="viewpress(scope.row)">跟踪审批</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query" />
                </div>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        components: {},
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                showhistory:false,
                instid:null,
                //查询属性
                q: {
                    pageSize:20,
                    pageNo:1,
                    total:0,
                    defkeyLike:null,
                    defnameLike:null,
                    instidLike:null,
                    ywidLike:null,
                    delflag:1,
                    reftype:null,
                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
            }
        },
        created() {
            this.query();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            query(p) {
                ss.proinstservice.page(this.q).then(rd=>{
                    this.q.total = rd.total
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },
            viewpress(r){
                this.showhistory = true;
                this.instid = r.id;
                // this.$router.push({path: '/process/viewpregress',query: {instid:r.id}})
            }
        }
    }
</script>
